import React, { useState } from "react";
import axios from "axios";
import configData from "../config.json";
import * as Icon from "react-bootstrap-icons";

const FirstMovingItems = () => {
  if (localStorage.getItem("branchID") === null) {
    window.location.replace("/");
  }

  const [itemData, setItemData] = useState([]);
  const [noResults, setNoResults] = useState(false);

  const [startDate, setStartDate] = useState(() => {
    return new Date().toISOString().split("T")[0];
  });

  const [endDate, setEndDate] = useState(() => {
    return new Date().toISOString().split("T")[0];
  });

  const handleSubmit = async () => {
    try {
      const res = await axios.get(
        configData.SERVER_URL +
          `/issueByDateRange/${startDate}/${endDate}/${localStorage.getItem(
            "branchID"
          )}`
      );

      setItemData(res.data);

      setNoResults(res.data.length === 0);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container-fluid">

      {/* HEADER */}
      <div className="card shadow-sm border-0">

        <div
          className="card-header d-flex justify-content-between align-items-center"
          style={{
                  background: "linear-gradient(135deg, #0d6efd, #0dcaf0)",
                  color: "#fff",
                  padding: "18px 25px",
                  border: "none",
                  }}
        >
          <h4 className="mb-0">
            <Icon.LightningFill /> First Moving Items
          </h4>
        </div>

        {/* FILTER SECTION */}
        <div className="card-body bg-light">

          <div className="row g-3 align-items-end">

            <div className="col-md-3">
              <label className="form-label">Date From</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Date To</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <button
                className="btn btn-primary w-100"
                onClick={handleSubmit}
              >
                <Icon.Search /> Search
              </button>
            </div>

          </div>
        </div>

        {/* EMPTY STATE */}
        {noResults && (
          <div className="text-center py-3 text-danger">
            <Icon.ExclamationCircle size={20} /> No results found
          </div>
        )}

        {/* TABLE */}
        <div className="card-body">
          <div className="table-responsive">

            <table className="table table-bordered table-hover table-striped align-middle">

              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Group</th>
                  <th>Item</th>
                  <th>Issue Qty</th>
                  <th>Unit</th>
                </tr>
              </thead>

              <tbody>
                {itemData.length > 0 ? (
                  itemData.map((data, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>
                        {data.groupCode} - {data.groupName}
                      </td>
                      <td>
                        {data.itemCode} - {data.itemName}
                      </td>
                      <td className="fw-bold text-primary">
                        {data.issueQty}
                      </td>
                      <td>{data.uom}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>

            </table>

          </div>
        </div>

      </div>
    </div>
  );
};

export default FirstMovingItems;